<script lang="ts">
    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
    import type { TileListItem } from '@tilelist/domain/composition/TileListitem.ts';

    interface Props {
        items: TileListItem[];
    }

    const MAX_PRODUCTS = 4;

    let { items }: Props = $props();

    const trackingData = $derived.by(() => {
        const pi: string[] = [];
        const vi: string[] = [];

        for (const item of items) {
            if (item.type === 'AS' && item.product.productType !== 'sponsored' && item.product.articleNumber) {
                pi.push(item.product.articleNumber);
                vi.push(item.product.bestVariationId);
                if (pi.length >= MAX_PRODUCTS) break;
            }
        }

        return {
            pi: pi.join(','),
            vi: vi.join(','),
        };
    });
</script>

<div
    id="reptile-exactag"
    class="exactag"
    data-trigger="sanProductList"
    data-pi={trackingData.pi}
    data-vi={trackingData.vi}
></div>
<!-- eslint-disable-next-line svelte/no-at-html-tags -->
{@html `<${'script'}>
(function() {
    var el = document.getElementById('reptile-exactag');
    if (el && window.otto) {
        window.otto.exactag.registerVerticalDataCallback('sanProductList', function() {
            var avContent = document.getElementById('avContent');
            var pt = (avContent && avContent.dataset.pt) || '';
            return {
                pt: pt,
                pi: el.dataset.pi || '',
                vi: el.dataset.vi || ''
            };
        });
    }
})();
</${'script'}>`}
